import React from 'react';
import Textfield from '@react/react-spectrum/Textfield';
import  Tooltip from '@react/react-spectrum/Tooltip';
const render_input = ({ input,placeholder, type, meta: { touched, error } }) => {
  const inputError = `input-wrapper ${error && touched ? 'input-error' : ''} `;
  let errorStyle = "";
  if(error && touched) {
    errorStyle =  "invalid";
  }
  const withoutValidationState = () => {
    return (
      <Textfield {...input} placeholder={placeholder} type={type}/>
    )
  }
  const withValidationState = () => {
    return (
      <Textfield {...input} placeholder={placeholder} type={type} validationState={errorStyle}/>
    )
  }

  return (
    <div className={inputError}>
      {errorStyle ? <div className="tooltip-error">
        <Tooltip placement="top" variant="error">
        {error}
        </Tooltip>
      </div> : ''}
      {errorStyle ? withValidationState() : withoutValidationState()}
    </div>
  )
}

export default render_input